import { render, staticRenderFns } from "./PortalPage.vue?vue&type=template&id=52596e84&scoped=true"
import script from "./PortalPage.vue?vue&type=script&lang=ts"
export * from "./PortalPage.vue?vue&type=script&lang=ts"
import style0 from "./PortalPage.vue?vue&type=style&index=0&id=52596e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52596e84",
  null
  
)

export default component.exports